module.exports = __webpack_public_path__ + "static/img/lessoncover.4e9e309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lessoncover.png
// module id = 4H0N
// module chunks = 0